import React, { useState } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { BriefcaseIcon, MapPinIcon, ClockIcon, CheckIcon, ArrowRightIcon } from 'lucide-react';
export const CareersPage = () => {
  const [scrolled, setScrolled] = useState(false);
  // Job listings
  const jobs = [{
    id: 1,
    title: 'Senior Product Designer',
    department: 'Design',
    location: 'Remote',
    type: 'Full-time',
    description: "We're looking for a Senior Product Designer to help shape the future of our marketplace platform and create exceptional experiences for creators and buyers.",
    requirements: ['At least 5 years of experience in product design', 'Experience designing for marketplace platforms', 'Strong portfolio demonstrating UX and UI skills', 'Ability to translate complex problems into simple solutions']
  }, {
    id: 2,
    title: 'Customer Support Specialist',
    department: 'Customer Success',
    location: 'Remote',
    type: 'Full-time',
    description: 'Join our customer success team to provide exceptional support to our community of creators and buyers, helping them navigate our platform and resolve issues.',
    requirements: ['Previous experience in customer support', 'Excellent communication skills', 'Problem-solving mindset', 'Passion for helping others']
  }, {
    id: 3,
    title: 'Full Stack Developer',
    department: 'Engineering',
    location: 'Remote',
    type: 'Full-time',
    description: "We're seeking a talented Full Stack Developer to join our engineering team and help build and maintain our marketplace platform.",
    requirements: ['Strong experience with React and Node.js', 'Experience with database design and management', 'Understanding of cloud infrastructure', 'Experience with payment processing systems a plus']
  }];
  // Benefits
  const benefits = [{
    title: 'Flexible Remote Work',
    description: 'Work from anywhere in the world with flexible hours',
    icon: <ClockIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-4842" />
  }, {
    title: 'Competitive Compensation',
    description: 'Salary packages that recognize your skills and experience',
    icon: <BriefcaseIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-4843" />
  }, {
    title: 'Health & Wellness',
    description: 'Comprehensive health insurance and wellness programs',
    icon: <HeartIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-4844" />
  }, {
    title: 'Professional Growth',
    description: 'Learning stipends and career development opportunities',
    icon: <GraduationCapIcon className="h-6 w-6 text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-4845" />
  }];
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-4846">
      <Navbar scrolled={scrolled} data-id="element-4847" />
      <main className="pt-24 pb-20" data-id="element-4848">
        <div className="container mx-auto px-4 md:px-6" data-id="element-4849">
          <div className="max-w-6xl mx-auto" data-id="element-4850">
            {/* Hero Section */}
            <div className="text-center mb-16" data-id="element-4851">
              <h1 className="text-3xl md:text-5xl font-bold mb-6 text-gray-800 dark:text-[#F8FAF9]" data-id="element-4852">
                Join Our Team
              </h1>
              <p className="text-xl text-gray-600 dark:text-[#B0C1BD] max-w-3xl mx-auto mb-8" data-id="element-4853">
                Help us build the future of digital marketplaces and empower
                creators around the world
              </p>
              <a href="#open-positions" className="inline-block bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] text-white px-8 py-3 rounded-lg text-lg font-medium hover:shadow-lg transition-all" data-id="element-4854">
                View Open Positions
              </a>
            </div>

            {/* Why Join Us */}
            <div className="bg-white dark:bg-[#162825] rounded-xl p-8 md:p-12 shadow-sm mb-16" data-id="element-4855">
              <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-4856">
                <div className="md:w-1/2" data-id="element-4857">
                  <h2 className="text-2xl md:text-3xl font-bold mb-4 text-gray-800 dark:text-[#F8FAF9]" data-id="element-4858">
                    Why Join DGStack?
                  </h2>
                  <p className="text-gray-600 dark:text-[#B0C1BD] mb-6" data-id="element-4859">
                    At DGStack, we're building a platform that empowers creators
                    to share their work with the world. We're a remote-first
                    company with team members across the globe, united by our
                    mission to create the best marketplace for digital products.
                  </p>
                  <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-4860">
                    We value creativity, innovation, and inclusivity. Our team
                    is passionate about creating exceptional experiences for
                    both creators and buyers, and we're looking for like-minded
                    individuals to join us on this journey.
                  </p>
                </div>
                <div className="md:w-1/2" data-id="element-4861">
                  <img src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80" alt="Team collaboration" className="rounded-xl w-full h-auto object-cover" data-id="element-4862" />
                </div>
              </div>
            </div>

            {/* Benefits */}
            <div className="mb-16" data-id="element-4863">
              <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center text-gray-800 dark:text-[#F8FAF9]" data-id="element-4864">
                Benefits & Perks
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-4865">
                {benefits.map((benefit, index) => <div key={index} className="bg-white dark:bg-[#162825] rounded-xl p-6 shadow-sm" data-id="element-4866">
                    <div className="w-12 h-12 rounded-full bg-[#2DB489]/10 flex items-center justify-center mb-4" data-id="element-4867">
                      {benefit.icon}
                    </div>
                    <h3 className="text-xl font-semibold mb-2 text-gray-800 dark:text-[#F8FAF9]" data-id="element-4868">
                      {benefit.title}
                    </h3>
                    <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-4869">
                      {benefit.description}
                    </p>
                  </div>)}
              </div>
            </div>

            {/* Open Positions */}
            <div id="open-positions" className="mb-16" data-id="element-4870">
              <h2 className="text-2xl md:text-3xl font-bold mb-8 text-center text-gray-800 dark:text-[#F8FAF9]" data-id="element-4871">
                Open Positions
              </h2>
              <div className="space-y-6" data-id="element-4872">
                {jobs.map(job => <div key={job.id} className="bg-white dark:bg-[#162825] rounded-xl p-6 shadow-sm hover:shadow-md transition-all" data-id="element-4873">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4" data-id="element-4874">
                      <div data-id="element-4875">
                        <h3 className="text-xl font-semibold text-gray-800 dark:text-[#F8FAF9]" data-id="element-4876">
                          {job.title}
                        </h3>
                        <p className="text-[#2DB489] dark:text-[#4ED1A0] font-medium" data-id="element-4877">
                          {job.department}
                        </p>
                      </div>
                      <div className="flex items-center mt-2 md:mt-0" data-id="element-4878">
                        <div className="flex items-center mr-4" data-id="element-4879">
                          <MapPinIcon className="h-4 w-4 text-gray-400 dark:text-[#7A8F8A] mr-1" data-id="element-4880" />
                          <span className="text-sm text-gray-600 dark:text-[#B0C1BD]" data-id="element-4881">
                            {job.location}
                          </span>
                        </div>
                        <div className="flex items-center" data-id="element-4882">
                          <ClockIcon className="h-4 w-4 text-gray-400 dark:text-[#7A8F8A] mr-1" data-id="element-4883" />
                          <span className="text-sm text-gray-600 dark:text-[#B0C1BD]" data-id="element-4884">
                            {job.type}
                          </span>
                        </div>
                      </div>
                    </div>
                    <p className="text-gray-600 dark:text-[#B0C1BD] mb-4" data-id="element-4885">
                      {job.description}
                    </p>
                    <h4 className="font-medium text-gray-800 dark:text-[#F8FAF9] mb-2" data-id="element-4886">
                      Requirements:
                    </h4>
                    <ul className="space-y-1 mb-6" data-id="element-4887">
                      {job.requirements.map((req, index) => <li key={index} className="flex items-start" data-id="element-4888">
                          <CheckIcon className="h-5 w-5 text-[#2DB489] dark:text-[#4ED1A0] flex-shrink-0 mr-2 mt-0.5" data-id="element-4889" />
                          <span className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-4890">
                            {req}
                          </span>
                        </li>)}
                    </ul>
                    <button className="inline-flex items-center text-[#2DB489] dark:text-[#4ED1A0] font-medium hover:underline" data-id="element-4891">
                      View Job Details
                      <ArrowRightIcon className="h-4 w-4 ml-1" data-id="element-4892" />
                    </button>
                  </div>)}
              </div>
            </div>

            {/* Application Process */}
            <div className="bg-white dark:bg-[#162825] rounded-xl p-8 md:p-12 shadow-sm mb-16" data-id="element-4893">
              <h2 className="text-2xl md:text-3xl font-bold mb-6 text-gray-800 dark:text-[#F8FAF9]" data-id="element-4894">
                Our Application Process
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-4895">
                <div className="flex flex-col items-center text-center" data-id="element-4896">
                  <div className="w-12 h-12 rounded-full bg-[#2DB489]/10 flex items-center justify-center mb-4 text-[#2DB489] dark:text-[#4ED1A0] font-bold text-xl" data-id="element-4897">
                    1
                  </div>
                  <h3 className="text-lg font-semibold mb-2 text-gray-800 dark:text-[#F8FAF9]" data-id="element-4898">
                    Application Review
                  </h3>
                  <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-4899">
                    Our team reviews your application and resume to assess your
                    qualifications and experience.
                  </p>
                </div>
                <div className="flex flex-col items-center text-center" data-id="element-4900">
                  <div className="w-12 h-12 rounded-full bg-[#2DB489]/10 flex items-center justify-center mb-4 text-[#2DB489] dark:text-[#4ED1A0] font-bold text-xl" data-id="element-4901">
                    2
                  </div>
                  <h3 className="text-lg font-semibold mb-2 text-gray-800 dark:text-[#F8FAF9]" data-id="element-4902">
                    Interview Process
                  </h3>
                  <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-4903">
                    Selected candidates go through 2-3 interviews with team
                    members and leadership.
                  </p>
                </div>
                <div className="flex flex-col items-center text-center" data-id="element-4904">
                  <div className="w-12 h-12 rounded-full bg-[#2DB489]/10 flex items-center justify-center mb-4 text-[#2DB489] dark:text-[#4ED1A0] font-bold text-xl" data-id="element-4905">
                    3
                  </div>
                  <h3 className="text-lg font-semibold mb-2 text-gray-800 dark:text-[#F8FAF9]" data-id="element-4906">
                    Offer & Onboarding
                  </h3>
                  <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-4907">
                    Successful candidates receive an offer and begin our
                    comprehensive onboarding process.
                  </p>
                </div>
              </div>
            </div>

            {/* Join Us CTA */}
            <div className="bg-gradient-to-r from-[#0A3C52] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-xl p-8 md:p-12 text-white text-center" data-id="element-4908">
              <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-4909">
                Don't See a Perfect Fit?
              </h2>
              <p className="text-lg opacity-90 mb-8 max-w-3xl mx-auto" data-id="element-4910">
                We're always looking for talented individuals to join our team.
                If you don't see a position that matches your skills, send us
                your resume anyway!
              </p>
              <button className="bg-white text-[#0A3C52] px-8 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors" data-id="element-4911">
                Send General Application
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-4912" />
    </div>;
};
// Custom icons
const HeartIcon = props => <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4913">
    <path d="M19.5 12.5717L12 20.0001L4.5 12.5717C3.33333 11.4051 2.75 9.99999 2.75 8.35558C2.75 5.19998 5.25 2.69995 8.4 2.69995C9.98 2.69995 11.5 3.49995 12 4.49995C12.5 3.49995 14.02 2.69995 15.6 2.69995C18.75 2.69995 21.25 5.19998 21.25 8.35558C21.25 9.99999 20.6667 11.4051 19.5 12.5717Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-4914" />
  </svg>;
const GraduationCapIcon = props => <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4915">
    <path d="M12 14L3 9L12 4L21 9L12 14Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-4916" />
    <path d="M19.5 11V16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-4917" />
    <path d="M5.5 10.5V15.5C5.5 15.5 8 18 12 18C16 18 18.5 15.5 18.5 15.5V10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-4918" />
  </svg>;